
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, OnInit } from '@angular/core';
import { FrameworkPhase, FrameworkKpiValue } from '../../lib/wwg.classes';
import { AuthService } from '../../sdk/services/core/auth.service';

@Component({
  selector: 'wwg-framework-kpi-data',
  templateUrl: './framework-kpi-data.component.html',
  styleUrls: ['./framework-kpi-data.component.scss']
})

export class FrameworkKpiDataComponent implements OnInit {

  public templateValues: Map<String, FrameworkKpiValue> = new Map<String, FrameworkKpiValue>();
  public phasesArray: Array<FrameworkPhase> = [];

  constructor(
  public authService: AuthService ) { }

  ngOnInit() { }

  public getValues() {
    return this.templateValues;
  }

  public setPhases(phases: Array<FrameworkPhase>) {
    if (Array.isArray(phases)) {
      this.phasesArray = phases;
      this.createTemplateValuesArray();
    }
  }

  private createTemplateValuesArray() {
    this.phasesArray.forEach((phase, id) => {
      if (phase.stages) {
        phase.stages.forEach((stage) => {
          if (!this.templateValues[stage._id]) {
            this.templateValues[stage._id] = new FrameworkKpiValue();
            this.templateValues[stage._id].createdBy = this.authService.getUserId();
            this.templateValues[stage._id].value = false;
          }
        });
      }
    });
  }

  public setValues(modelValues: Array<FrameworkKpiValue>) {
    this.templateValues = Object.assign(modelValues, this.templateValues);
  }
}
